import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'APN' })

export class APNPipe implements PipeTransform
{
    transform(value: string, delim: string) :string
    {
        return value.length === 9? value.substring(0, 3) + delim + value.substring(3, 6) + delim + value.substring(6, 9): value;
    }
}